module.exports = __webpack_public_path__ + "img/gamesdk5.c855633.png";